module.exports = __webpack_public_path__ + "img/1_023.56860e42.jpg";